"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ForgotPassword {
}
exports.ForgotPassword = ForgotPassword;
//# sourceMappingURL=ForgotPassword.js.map